import http from 'hub-http/clients/apiClient';
import { getGSEnrollmentUserAttributeKey } from '../gettingStartedEnrollment';
import { getHubletUrl } from '../utils/apiUtils';
const USER_ATTRIBUTES_URI = `users/v1/app/attributes`;
export function changeEnrollmentUserAttributes(isEnrolled, userId, portalId, options = {}) {
  const {
    hubletOriginOverride
  } = options;
  return http.post(getHubletUrl(USER_ATTRIBUTES_URI, hubletOriginOverride), {
    data: {
      userId,
      key: getGSEnrollmentUserAttributeKey(portalId),
      value: isEnrolled,
      enrolledInUserGuide: isEnrolled
    }
  });
}